import React, { useContext, useState } from 'react';
import GalleryGrid from '../GalleryGrid';
import ImageModal from '../ImageModal';
import './GalleryPage.css';
import Constants from '../../locals/constants.json'
import { LanguageContext } from '../../context/LanguageContext';


const GalleryPage = () => {
  const {t} = useContext(LanguageContext);
  
  window.scroll(0,0);
  
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState('all');

  const galleryImages = Constants["galleryImages"];

  const handleImageClick = (index) => {
    setSelectedImage(index);
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  const filteredImages = selectedFilter === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === selectedFilter);

  return (
    <div className="gallery-wrapper">
      <section className="gallery-header">
        <h1 className="gallery-title">{t("gallery", "title")}</h1>
        <p className="gallery-description">
          {t("gallery", "subtitle")}
        </p>
      </section>

      {/* Filters */}
      <div className="gallery-filters">
        <button 
          className={`filter-btn ${selectedFilter === 'all' ? 'active' : ''}`}
          onClick={() => setSelectedFilter('all')}
        >
          {t("gallery", "filters")["all"]}
        </button>
        <button 
          className={`filter-btn ${selectedFilter === 'rooms' ? 'active' : ''}`}
          onClick={() => setSelectedFilter('rooms')}
        >
          {t("gallery", "filters")["rooms"]}
        </button>
        <button 
          className={`filter-btn ${selectedFilter === 'spaces' ? 'active' : ''}`}
          onClick={() => setSelectedFilter('spaces')}
        >
          {t("gallery", "filters")["spaces"]}
        </button>
        <button 
          className={`filter-btn ${selectedFilter === 'exterior' ? 'active' : ''}`}
          onClick={() => setSelectedFilter('exterior')}
        >
          {t("gallery", "filters")["exterior"]}
        </button>
      </div>

      {/* Gallery Grid */}
      <GalleryGrid 
        images={filteredImages} 
        onImageClick={handleImageClick}
      />
          
        

      {selectedImage !== null && (
        <ImageModal
          images={filteredImages}
          currentIndex={selectedImage}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default GalleryPage;